import React from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Column } from "./types";

type HandleClick = (
  event: React.MouseEvent<HTMLButtonElement>,
  value: string,
) => void;

type CustomEvent = (event: string, value?: string) => void;

interface TableProps {
  columns: Column[];
  rows: Array<Record<string, any>>;
  TableList: React.ComponentType<{
    row: Record<string, any>;
    columns: Column[];
    handleClick: HandleClick;
    handleCustomEvent: CustomEvent;
  }>;
  handleClick: HandleClick;
  handleCustomEvent: CustomEvent;
}

export default function TableView({
  columns,
  rows,
  handleClick,
  handleCustomEvent,
  TableList,
}: TableProps): JSX.Element {
  return (
    <Table
      stickyHeader
      aria-label="sticky table"
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        minWidth: 650,
        background: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        "& .MuiTableCell-root": {
          borderBottom: "1px solid #f0f1f3",
          fontSize: { xs: 13, sm: 15 },
          paddingY: { xs: 1, sm: 1.5 },
          paddingX: { xs: 1, sm: 2 },
        },
        "& .MuiTableRow-root:hover": {
          background: "#f7fafd",
        },
        "& .MuiTableHead-root .MuiTableCell-root": {
          background: "#fafbfc",
          fontWeight: 800,
          fontSize: 16,
          color: "#23272E",
          letterSpacing: 0.04,
          borderBottom: "none",
          paddingY: 2.2,
          paddingX: 2,
        },
        "& .MuiTableHead-root .MuiTableCell-root:first-of-type": {
          borderTopLeftRadius: 0,
        },
        "& .MuiTableHead-root .MuiTableCell-root:last-of-type": {
          borderTopRightRadius: 0,
        },
        "& .MuiTableBody-root .MuiTableCell-root": {
          background: "#fff",
        },
      }}
    >
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
              {column.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.length
          ? rows.map((row: Record<string, any>) => {
              return (
                <TableList
                  key={row.id}
                  row={row}
                  columns={columns}
                  handleClick={handleClick}
                  handleCustomEvent={handleCustomEvent}
                />
              );
            })
          : null}
      </TableBody>
    </Table>
  );
}
